import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './linkedinImport.css';

const StepLinkedInImport = ({ onComplete, onBack, theme }) => {
  const [connecting, setConnecting] = useState(false);

  const handleLinkedInConnect = async () => {
    setConnecting(true);

    try {
      // Initiate LinkedIn OAuth flow
      // Redirect to your backend LinkedIn auth endpoint
      window.location.href = '/api/auth/linkedin';
    } catch (err) {
      setConnecting(false);
    }
  };

  return (
    <div className="lii-container">
      <button className="lii-back-nav" onClick={onBack}>
        ← Back
      </button>

      <div className="lii-header">
        <h1>Connect Your LinkedIn Profile</h1>
        <p>We'll securely import your professional information from LinkedIn.</p>
      </div>

      <motion.div
        className="lii-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="lii-info">
          <div className="lii-info-item">
            <span className="lii-check">✓</span>
            <span>Your profile information will be imported</span>
          </div>
          <div className="lii-info-item">
            <span className="lii-check">✓</span>
            <span>You can edit everything in the form</span>
          </div>
          <div className="lii-info-item">
            <span className="lii-check">✓</span>
            <span>We never post to your account</span>
          </div>
        </div>

        <button
          className={`lii-connect-btn ${connecting ? 'connecting' : ''}`}
          onClick={handleLinkedInConnect}
          disabled={connecting}
        >
          {connecting ? (
            <>
              <div className="lii-spinner"></div>
              <span>Connecting...</span>
            </>
          ) : (
            <>
              <span className="lii-linkedin-icon">in</span>
              <span>Continue with LinkedIn</span>
            </>
          )}
        </button>

        <p className="lii-disclaimer">
          By connecting, you agree to our Terms of Service and Privacy Policy.
        </p>
      </motion.div>
    </div>
  );
};

export default StepLinkedInImport;
